import {STATUS_CARD, HAN_THE_OPTIONS} from "assets/constants/card-types";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {ColumnsEdit} from "types/models/column-table-edit";

const {
  INPUT,
  DATE,
  SELECT,
  AUTO_COMPLETE,
  CURRENCY,
  DATE_ON,
  NUMBER,
  CHECKBOX,
  RADIO,
  NORMAL_CHECKBOX,
} = FIELD_TYPE;

const cssProps = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 8, xl: 8},
};

const cssProps2 = {
  labelCol: {xs: 8, sm: 8, md: 8, lg: 8, xl: 8},
  wrapperCol: {xs: 16, sm: 16, md: 16, lg: 16, xl: 16},
  css: {xs: 24, sm: 24, md: 24, lg: 12, xl: 12},
};
const dataFields = [
  {
    type: INPUT,
    name: "maLoaiThe",
    label: "Mã loại thẻ",
    allowClear: true,
    ...cssProps,
  },
  {
    type: INPUT,
    name: "tenLoaiThe",
    label: "Tên loại thẻ",
    allowClear: true,
    ...cssProps,
  },
  {
    type: SELECT,
    name: "trangThai",
    label: "Trạng thái",
    options: STATUS_CARD,
    allowClear: true,
    ...cssProps,
  },
  {
    type: DATE,
    name: 'start',
    label: "Từ ngày",
    ...cssProps,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
  },
  {
    type: DATE,
    name: 'end',
    label: 'Đến ngày',
    ...cssProps,
    optionsTime: { format: FORMAT_TIME.dayFull, showTime: true },
  },
  {
    type: SELECT,
    name: "thoiHan",
    label: "Hạn thẻ",
    options: HAN_THE_OPTIONS,
    allowClear: true,
    ...cssProps,
  },
];
const cardTypesInfo = [
  {
    name: "id",
    type: INPUT,
    hide: true,
  },
  {
    type: INPUT,
    name: "maLoaiThe",
    label: "Mã loại thẻ",
    ...cssProps2,
    rules: [{required: true, message: "Mã loại thẻ là bắt buộc!"}]
  },
  {
    type: INPUT,
    name: "tenLoaiThe",
    label: "Tên loại thẻ",
    ...cssProps2,
    rules: [{required: true, message: "Tên loại thẻ là bắt buộc!"}]
  },
  {
    label: "Giá bán",
    type: CURRENCY,
    name: "giaBan",
    placeHolder: "Nhập",
    ...cssProps2,
    rules: [{required: true, message: "Giá bán là bắt buộc!"}]
  },
  {
    name: "trangThai",
    hide: true,
  },
  {
    label: "Thời hạn (tháng)",
    name: "thoiHan",
    type: NUMBER,
    ...cssProps2,
  },
  {
    label: "Điều kiện khác",
    name: "dieuKienKhac",
    type: INPUT,
    ...cssProps2,
  },
  {
    label: "Ghi chú",
    name: "ghiChu",
    type: INPUT,
    ...cssProps2,
  },
  {
    type: NORMAL_CHECKBOX,
    label: "Thẻ gia đình",
    name: "theGiaDinh",
    valuePropName: "checked",
    ...cssProps2,
  },
];

const columns = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    render: (v, r, i) => i + 1,
    align: "center",
  },
  {
    title: "Mã loại thẻ",
    dataIndex: "maLoaiThe",
    show: true,
    align: "center",
  },
  {
    title: "Tên loại thẻ",
    dataIndex: "tenLoaiThe",
    show: true,
    align: "left",
  },
  {
    title: "Trạng thái",
    dataIndex: "trangThai",
    show: true,
    align: "left",
    render: (v, r, i) => STATUS_CARD.find(it => it.value === v)?.label || "",
  },
  {
    title: "Số lượt bán",
    dataIndex: "soLuotBan",
    show: true,
    align: "center",
  },
  {
    title: "Thao tác",
    dataIndex: "action",
    show: true,
    align: "center",
  },
];

export {dataFields, cardTypesInfo, columns};
